/**
 * This file is included on every page and adds URL parameters to the targets of links that have the
 * data-tracking-name attribute set. This is used to track the learning session funnel.
 */
module.exports = function ($, M) {
  $('body').on('click', 'a[data-tracking-name]', event => {
    const link = $(event.currentTarget);
    let url = new URL(link.prop('href'));
    const pageElementId = link.attr('data-tracking-name');
    if (pageElementId) {
      url.searchParams.set('source_element', pageElementId);
      if (M.page_id) {
        url.searchParams.set('source_screen', M.page_id);
      }
    }
    link.prop('href', url.href);
  });
};
